var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWrench(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 76.9 76.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2,.cls-3{fill:none;stroke-miterlimit:10;}.cls-2{stroke:#fff;stroke-width:0.9px;}.cls-3{stroke:#018b9d;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Wrench") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 38.45,
    cy: 38.45,
    r: 32.67
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 38.45,
    cy: 38.45,
    r: 38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 40.79,
    y1: 39.44,
    x2: 44.01,
    y2: 42.66
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 47.39,
    y: 40.13,
    width: 5.47,
    height: 17.31,
    transform: "translate(-19.81 49.73) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "25.33 27.85 29.19 23.98 22.75 20.12 21.46 21.41 25.33 27.85"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 35.63,
    y1: 34.29,
    x2: 27.26,
    y2: 25.92
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M55,25.6,49.8,28l-2.58-2.66,2.25-5.19h0c-6.44,0-8.05,3.18-8.05,6.4v2.58L19.85,51,18.73,54.9l1.37,1.29,3.9-1L45.94,33.65h2.58C51.74,33.65,55,32,55,25.6Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrench);
export default __webpack_public_path__ + "static/media/Wrench.97c653cee59a39ebc06bc8d7c009c562.svg";
export { ForwardRef as ReactComponent };